import { React, useState } from 'react';
import { TextField } from '@material-ui/core';
import './Order.css';
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";

function Orders() {

    const firebaseConfig = {
        apiKey: "AIzaSyAiW1B-on8Yb2kF1P0BdMI620gG9ZvQP98",
        authDomain: "venom-official-site.firebaseapp.com",
        databaseURL: "https://venom-official-site-default-rtdb.firebaseio.com",
        projectId: "venom-official-site",
        storageBucket: "venom-official-site.appspot.com",
        messagingSenderId: "1005302460208",
        appId: "1:1005302460208:web:710ed3ba884096b3f6a2f5"
      };
      
    const app = initializeApp(firebaseConfig);
    const db = getFirestore();

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [description, setDescription] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const docRef = await addDoc(collection(db, "orders"), {
              name: name,
              email: email,
              description: description
            });
            console.log("Document written with ID: ", docRef.id);
          } catch (e) {
            console.error("Error adding document: ", e);
          }

        setName('');
        setEmail('');
        setDescription('');
    }

    return (
        <div>
            <div className='order'>
                <div className='ordertext'>
                    <h1 className='text1'>Order</h1>
                </div>
                <form className='form' onSubmit={handleSubmit}>
                    <div>
                        <TextField className='texti' id="outlined-basic" label="Name" variant="outlined" value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className='mergin'>
                        <TextField className='texti3' id="outlined-basic" label="Email" variant="outlined" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className='mergin2'>
                        <TextField className='texti4' id="outlined-basic" label="Description" variant="outlined" value={description} onChange={(e) => setDescription(e.target.value)} />
                    </div>
                    <input className='button' type="submit" value="Submit" />
                    <h1 className='texti2'>Pls Contact 0777110035 for details and to order</h1>
                </form>
            </div>
        </div>
    )
}

export default Orders
